import type {
  TApiHttpClientRequestConfig,
  TPaginated,
  TPaginationRequest,
  TSearchable,
  TSortingRequest,
} from '~/misc/resource/types';
import type { EUserRole } from '~/misc/user/types';
import type { ESubscriptionType } from '~/modules/manager/types';

type TUserPatch = {
  id: number;
  name: string;
};
// TODO: put in order types on https://addintel.atlassian.net/browse/RC-256
type TNewUser = {
  id?: number;
  email: string;
  role: EUserRole;
  name: string;
  patches: number[];
};

type TUser = TNewUser & {
  id: number;
  patches: TUserPatch[];
  subscriptions?: ESubscriptionType[];
  is_active: boolean;
  last_visit: string | null;
};

type TPaginatedUsers = TPaginated<TUser>;

type TErrors = {
  email?: string;
  name?: string;
  patches?: string;
};

enum EUserSorting {
  ACTIVE = 'active',
  EMAIL = 'email',
  NAME = 'name',
  ROLE = 'role',
  SUBSCRIBED_SALES = 'subscribed_sales',
  SUBSCRIBED_LETTINGS = 'subscribed_lettings',
  AREAS = 'areas',
  LAST_VISIT = 'last_visit',
}

enum EUserFilters {
  ACTIVE = 'active',
  SUBSCRIBED_SALES = 'subscribed_sales',
  SUBSCRIBED_LETTINGS = 'subscribed_lettings',
}

type TUserFiltersRequest = {
  filters?: Partial<Record<EUserFilters, number>>;
};

type TUserIndexPayload = TPaginationRequest &
  TSearchable &
  TSortingRequest<EUserSorting> &
  TUserFiltersRequest;

interface IUserResourceModel {
  index(
    payload: TUserIndexPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedUsers>;

  store(payload: TNewUser, requestConfig?: TApiHttpClientRequestConfig): Promise<TUser>;

  update(
    id: number,
    payload: TNewUser,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TUser>;

  destroy(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void>;
}

export type {
  TNewUser,
  TUser,
  TPaginatedUsers,
  TErrors,
  TUserPatch,
  IUserResourceModel,
  TUserIndexPayload,
};

export { EUserSorting, EUserFilters };
